import { safeDifferenceInCalendarDays, safeFormatReadableDate } from 'shared/util/datetime-fns';

import type { Filters } from '@/interfaces';
import { generateRoomInfoText } from '@/containers/travellersPicker/TravellersPicker';

export type SearchFormPreviewProps = Pick<Filters, 'checkInDate' | 'checkOutDate' | 'rooms'> & { destinationFullName?: string };

export const SearchFormPreview = ({ destinationFullName, checkInDate, checkOutDate, rooms }: SearchFormPreviewProps) => {
    const daysBetween = safeDifferenceInCalendarDays(checkInDate, checkOutDate);
    return (
        <div data-testid="searchFormPreview" className="search-form-preview">
            <div className="u-t4 u-mb4 date-preview" data-testid="searchFormPreview-dateInfo">
                {checkInDate || checkOutDate ? (
                    <>
                        <span className="u-no-break">{safeFormatReadableDate(checkInDate)}</span>
                        <span className="u-mh8">-</span>
                        <span className="u-no-break">{safeFormatReadableDate(checkOutDate)}</span>
                        {daysBetween && (
                            <span className="u-ml8 u-no-break u-normal">{`(${daysBetween} ${daysBetween > 1 ? 'netter' : 'natt'})`}</span>
                        )}
                    </>
                ) : (
                    'Dato er ikke valgt'
                )}
            </div>
            {destinationFullName && (
                <div className="destination-preview" data-testid="searchFormPreview-destinationInfo">
                    {destinationFullName}
                </div>
            )}
            <div className="u-stone room-preview" data-testid="searchFormPreview-roomInfo">
                {generateRoomInfoText(rooms)}
            </div>
        </div>
    );
};
